import { Attribute } from '~/modules/vizulo/attributes/types';
import useApi from '~/composables/useApi';
import attributesGql from '~/modules/vizulo/attributes/attributes.gql';

interface AttributesOutput {
	items: Array<Attribute>
}

export const useAttributes = () => {
	const { query } = useApi();
    
	const getAttributes = async (filter): Promise<Array<Attribute>> => {
		const { data } = await query<{ attributes: AttributesOutput }>(attributesGql, { filter });

		return data?.attributes?.items ?? [];
	}

	return {
		getAttributes,
	}
}